export default {
  'get-list': {
    method: 'post',
    url: '/admincp/business/task/list'
  },
  getById: {
    method: 'get',
    url: '/admincp/business/task/ID'
  },
  delete: {
    method: 'delete',
    url: '/admincp/business/task'
  },
  archive: {
    method: 'delete',
    url: '/admincp/business/task/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/business/task/restore'
  },
  add: {
    method: 'post',
    url: '/admincp/business/task'
  },
  edit: {
    method: 'put',
    url: '/admincp/business/task/ID'
  },
  select: {
    method: 'get',
    url: '/admincp/business/task/find?key=KEY&taskType=TASKTYPE'
  }
}
